import { css } from '@/styled-system/css';
import { styled } from '@/styled-system/jsx';
import { shimmerStyles } from '@zg-rentals/loading-components';
import { Link } from 'react-router-dom';

export const propertyPhotoContainerStyles = css.raw({
  display: { base: 'none', mobile390: 'inherit' },
  width: { mobile390: '76px' },
  height: { mobile390: '76px', lg: '87px' },
  borderRadius: { mobile390: 'obj.default' },
  marginBottom: { mobile390: '400', lg: '0px' },
  marginRight: { mobile390: '200', lg: '400' },
  minWidth: { lg: '87px', xl: '122px' },
  maxWidth: { lg: '87px', xl: '122px' },
  backgroundRepeat: { mobile390: 'no-repeat' },
  backgroundPosition: { mobile390: 'center center' },
  ...shimmerStyles,
});

export const StyledLink = styled(Link, {
  base: {
    marginRight: '400',
    alignSelf: 'baseline',
    lg: {
      marginRight: '600',
      marginTop: '200',
    },
    _visited: {
      color: 'text.neutral',
    },
  },
});
